export default __webpack_public_path__ + "static/media/DrawButtonGlow.6c22cebd.png";